module.exports = __webpack_public_path__ + "static/img/bg-h.ac98aab1.jpg";